import { adminAPIInstance, axiosInstance } from "./axiosInstance";

export const getAllReport = async (page, per_page = 50, search, is_resolved, reportable_type) => {
  try {
    const { data } = await axiosInstance.get("report", {
      params: {
        page: page,
        per_page: per_page,
        search: search,
        is_resolved: is_resolved,
        reportable_type: reportable_type
      },
    });

    return data;

  } catch (error) {
    console.log(error);
  }
};

export const updateReportStatus = async (report_id,values) => {
  try {

    const data = await axiosInstance.post(`report/update/review/${report_id}`, {
      is_resolved: values.report.is_resolved === true ? 1: 0,
      to_unpublish: values.publish.to_unpublish === true ? 1: 0
    });



    if(data)
    return data;

  } catch (error) {
    console.log(error);
  }
};
